export default "__VITE_ASSET__DP0HQX7w__"